module.exports = __webpack_public_path__ + "img/aidt (1).c17d83b2.jpg";